import * as React from "react"
import ToolbarComponent, {
	ButtonToolbarItem,
	LinkToolbarItem,
	ToolbarItem
} from "./toolbar-component"
import { User } from "../../model"
import "./style.scss"

class Toolbar extends React.Component<ToolbarProps> {
	render() {
		return <ToolbarComponent
		items={this.props.items}
		loading={this.props.loading}
		user={this.props.user} />
	}
}

export default Toolbar

export interface ToolbarProps {
	items?: ToolbarItem[]
	loading?: boolean
	user: User
}

export { ButtonToolbarItem, LinkToolbarItem, ToolbarItem }


// WEBPACK FOOTER //
// ./src/component/toolbar/index.tsx